import { createAuthenticatedFetch } from "@assetwatch/auth";
import { addWorkApiBreadcrumb, createWorkId } from "../lib/sentry";
import { getSimulatedWorkRole } from "./workRoleOverride";

const baseAuthenticatedFetch = createAuthenticatedFetch({
  createRequestId: () => createWorkId("req"),
  onBreadcrumb: addWorkApiBreadcrumb,
});

export async function authenticatedFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
) {
  const headers = new Headers(init?.headers);
  const role = getSimulatedWorkRole();
  if (role) {
    headers.set("X-Work-Simulated-Role", role);
  } else {
    headers.delete("X-Work-Simulated-Role");
  }
  return baseAuthenticatedFetch(input, { ...init, headers });
}
